/** Pure selection helpers for MultiSelect, split out so the component file
 *  stays components-only (keeps React Fast Refresh working) and the array
 *  logic is unit-testable without rendering. */

/** Append `value` if absent, remove it if present. Returns a new array. */
export function toggleValue(values: string[], value: string): string[] {
  return values.includes(value) ? values.filter((v) => v !== value) : [...values, value];
}

/** Remove `value` if present. Returns a new array. */
export function removeValue(values: string[], value: string): string[] {
  return values.filter((v) => v !== value);
}

/** The empty selection. */
export function clearValues(): string[] {
  return [];
}
